export enum EAccountingPeriods {
  MONTH = 'month',
  YEAR = 'year',
}
